import './style.scss';
import TicketSuggestions from '../../Shared/TicketSuggestions';
import { SanitizerService } from '../../../services/sanitizer.service';
import { TranslationService } from '../../../services/translation.service';
import { type IAreaTicket } from '../../../models/area-ticket-model';
import { type IMunicipality } from '../../../models/municipality.model';

function AreaTicket({ areaTicket, searchedMunicipalities = [], isDetailsPage = false }: { areaTicket: IAreaTicket; searchedMunicipalities?: IMunicipality[]; isDetailsPage?: boolean }) {
  // === CONSTANTS ===
  const translationMap = TranslationService.get('common.map');

  // === VARAIBLES ===
  const imageAltText = `${translationMap} ${areaTicket.name}`;

  function validityWithHighlightedMunicipalities() {
    let result = areaTicket.validityTextAsHtml;
    for (let i = 0; i < searchedMunicipalities.length; i += 1) {
      const municipalityName = searchedMunicipalities[i].name;
      result = result.replace(municipalityName, `<strong>${municipalityName}</strong>`);
    }
    return result;
  }

  return (
    <div className="area-ticket p-3">
      {isDetailsPage ? <h2 className="h3">{areaTicket.name}</h2> : <h3>{areaTicket.name}</h3>}
      <div dangerouslySetInnerHTML={{ __html: SanitizerService.sanitizeHtml(validityWithHighlightedMunicipalities()) }}></div>
      <div dangerouslySetInnerHTML={{ __html: SanitizerService.sanitizeHtml(areaTicket.descriptionAsHtml) }}></div>
      <TicketSuggestions id={areaTicket.areaId.toString()} ticketSuggestions={areaTicket.ticketSuggestions}></TicketSuggestions>
      {areaTicket.imageUrl && <img className="mt-3" src={areaTicket.imageUrl} alt={imageAltText} />}
    </div>
  );
}

export default AreaTicket;
